<template>
    <div>
        <div v-if="!dataset.some(x => x.item1.length != 0)" class="alert-no-alarms">{{$t('NoAlarmsInRange')}}</div>
        <div class="vertical" style="height:80vh; width:90vw;">
            <div ref="multipleFilters" id="multipleFilters" class="vertical" style="justify-content: space-around">
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="padding-left: 5px;" class="info-field-value">
                            <datepicker :dateFrom="dateFrom" :dateTo="dateTo" :min="dateWeekAgo" :max="new Date()" @dateChanged="dateChanged"></datepicker>
                        </td>
						<td>
							<div style="display: grid; align-content: center;">
								<div style="margin-left: 20px;" class='horizontal'>
									<p class="info-field-title" style="align-self: center; margin-left: 10px;">{{$t('AllAlarmTypes')}}</p>
									<VueToggles :value="allAlarmTypesOption" @click="allAlarmTypesOption = !allAlarmTypesOption" checkedBg="#0095b2" uncheckedBg="lightgrey" width="50" height="25"></VueToggles>

								</div>
							</div>
						</td>
                    </tr>
                </div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
						<td>
							<alarm-types-select :system-id="systemId" :date-from="dateFrom" :date-to="dateTo" :priority="activeSet" :all-types="allAlarmTypesOption" :pre-selected-alarm="selectedAlarmType" @alarmTypeChanged="(aT) => changeAlarmType(aT)"></alarm-types-select>
						</td>
                    </tr>
                </div>
            </div>

            <div :id="'scichart-root-' + sid" :style="`width: 100%; height: 80vh; margin-right: 10px; align-self: center;`"></div>
        </div>
    </div>
</template>

<script>
import { SciChartSurface } from "scichart/Charting/Visuals/SciChartSurface";
import { NumericAxis } from "scichart/Charting/Visuals/Axis/NumericAxis";
import { CategoryAxis } from "scichart/Charting/Visuals/Axis/CategoryAxis";
import { EAxisAlignment } from "scichart/types/AxisAlignment";
import { FastLineRenderableSeries } from "scichart/Charting/Visuals/RenderableSeries/FastLineRenderableSeries";
import { XyDataSeries } from "scichart/Charting/Model/XyDataSeries";
import { ZoomPanModifier } from "scichart/Charting/ChartModifiers/ZoomPanModifier";
import { MouseWheelZoomModifier } from "scichart/Charting/ChartModifiers/MouseWheelZoomModifier";
import { RubberBandXyZoomModifier } from "scichart/Charting/ChartModifiers/RubberBandXyZoomModifier";
import { ZoomExtentsModifier } from "scichart/Charting/ChartModifiers/ZoomExtentsModifier";
import { YAxisDragModifier } from "scichart/Charting/ChartModifiers/YAxisDragModifier";
import { chartThemeMixin } from "@/utils/chartTheme";
import { NumberRange } from "scichart/Core/NumberRange";
import { RolloverModifier } from "scichart/Charting/ChartModifiers/RolloverModifier";
import { CursorModifier } from "scichart/Charting/ChartModifiers/CursorModifier";
import { EllipsePointMarker } from "scichart/Charting/Visuals/PointMarkers/EllipsePointMarker";
import { EXyDirection } from "scichart/types/XyDirection";
import { ELineDrawMode } from "scichart/Charting/Drawing/WebGlRenderContext2D"
import { EAutoRange } from "scichart/types/AutoRange";
import { EDragMode } from "scichart/types/DragMode";
import { VerticalLineAnnotation } from "scichart/Charting/Visuals/Annotations/VerticalLineAnnotation";
import { ELabelPlacement } from "scichart/types/LabelPlacement";

import moment from 'moment'
import { GridPlugin, Sort, Page, Filter, Toolbar, Search, CommandColumn } from '@syncfusion/ej2-vue-grids';
import Datepicker from '../Datepicker.vue';
import { LabelProvider } from 'scichart/Charting/Visuals/Axis/LabelProvider/LabelProvider';
import AlarmTypesSelect from "../Filters/AlarmTypesSelect";

import VueToggles from 'vue-toggles';

export default {
	mixins: [chartThemeMixin],
	components: {AlarmTypesSelect, Datepicker, VueToggles },
    props: ['systemId', 'dataset', 'devices', 'allAlarmTypes', 'activeSet', 'labelX', 'labelY', 'zoom', 'pan', 'showValues', 'mouseZoom', 'sid', 'initialZoomOut'],
    provide: {
        grid: [ Sort, Page, Filter, Toolbar, Search, CommandColumn ],
    },
    data() {
        var dateWeekAgoTemp = new Date();
        dateWeekAgoTemp.setDate(dateWeekAgoTemp.getDate() - 7)
        dateWeekAgoTemp = new Date(dateWeekAgoTemp.getFullYear(), dateWeekAgoTemp.getMonth(), dateWeekAgoTemp.getDate())

        return {
            sciChartSurface: null,
            wasmContext: null,
            selection: [],
            init: false,
            changingType: false,
            allAlarmTypesOption: false,
			sciChartHeight: '80vh',

            dateWeekAgo: dateWeekAgoTemp,
            dateFrom: dateWeekAgoTemp,
            dateTo: new Date(),
            selectedAlarmType: "",
            data: [],
            availableAlarmTypes: [],
            resizeObserver: null
        }
    },
    computed: {
        activeTab() {
            return this.activeSet
        },
        datasetComputed() {
            return this.dataset
        },
		// filtersHeight() {
		// 	if(this.$refs.multipleFilters !== undefined){
		// 		return this.$refs.multipleFilters.offsetHeight
		// 	} else {
		// 		return 0
		// 	}
		// }
    },
    watch: {
        datasetComputed(newVal, oldVal) {
            this.checkAvailableAlarmTypes()
            this.changeDataSet(newVal, false)
        },
        activeTab(newVal, oldVal) {
            if(newVal != 0) {
                this.checkAvailableAlarmTypes()
                this.changeDataSet(newVal, false)
            }
        },
        selectedAlarmType(newVal, oldVal){
            if(!this.changingType) {
                this.changeDataSet(this.activeSet, false)
            }
        },
        allAlarmTypesOption(newVal, oldVal) {
            if(newVal == false) {
                this.checkAvailableAlarmTypes()
                this.changeDataSet(this.activeSet, false)
            }
			this.refreshChartSize()
        },
    },
    methods: {
        async initSciChart() {
            const {sciChartSurface, wasmContext} = await SciChartSurface.create("scichart-root-" + this.sid);

            this.sciChartSurface = sciChartSurface;
            this.wasmContext = wasmContext;

            sciChartSurface.applyTheme(this.chartTheme())

            const xAxis = new NumericAxis(this.wasmContext, {
                axisAlignment: EAxisAlignment.Top,
                drawMajorBands: true,
                majorGridLineStyle: {
                    color: "#9D9D9D",
                },
            });

            const yAxis = new NumericAxis(this.wasmContext, { axisAlignment: EAxisAlignment.Left});
            yAxis.labelProvider.formatLabel = (dataValue) => parseInt(dataValue);
            // yAxis.autoTicks = false;
            yAxis.maxAutoTicks = this.devices * 2;
            yAxis.minorsPerMajor = 2
            yAxis.visibleRange = new NumberRange(1, this.devices);


            if(this.initialZoomOut == true){
                yAxis.growBy = new NumberRange(0.02, 0.02);
                xAxis.growBy = new NumberRange(0.02, 0.02);
            }

            this.sciChartSurface.xAxes.add(xAxis)
            this.sciChartSurface.yAxes.add(yAxis)

            // xAxis.labelProvider.formatCursorLabel = (dt) => {
            //     return moment(dt).format("MM.DD, HH:mm:ss")
            // }

            xAxis.labelProvider.formatLabel = (unixTimestamp) => {
                var formated = new Date()
                formated = moment(unixTimestamp).format("DD.MM")
                return formated
            };

            // xAxis.labelProvider.formatLabel = (dt) => {
            //     return moment(dt).format("MM.DD, HH:mm:ss")
            // }

            // xAxis.labelProvider.formatCursorLabel = (dt) => {
            //     return moment(dt).format("MM.DD, HH:mm:ss")
            // }

            sciChartSurface.annotations.add(
              new VerticalLineAnnotation({
                      labelPlacement: ELabelPlacement.Axis,
                      showLabel: true,
                      stroke: "Red",
                      strokeThickness: 2,
                      x1: Date.now(),
                      axisLabelFill: "Red",
                      labelValue: this.$t("Now")
                  }),
            );

            await this.populateSciChart(true)

            xAxis.autoTicks= false,
            xAxis.majorDelta= 86400000;
            xAxis.minorDelta= 17280000;
            let lastRange = 2;

            xAxis.visibleRangeChanged.subscribe((args) => {
                let rangeDiff = args.visibleRange.max - args.visibleRange.min;

                if (rangeDiff/3600000 <= 6 && lastRange != 0) {
                  xAxis.majorDelta= 600000;
                  xAxis.minorDelta= 120000;
                  lastRange = 0;

                  xAxis.labelProvider.formatLabel = (unixTimestamp) => {
                    var s = new Date(unixTimestamp)
                    s = new Date(s.getFullYear(), s.getMonth(), s.getDate(), s.getHours(), s.getMinutes(), s.getSeconds())
                    var formated = moment(s).format("DD.MM, HH:mm:ss")
                    return formated
                  };

                } else if ( rangeDiff/3600000 > 6 && rangeDiff / 86400000 <= 2 && lastRange != 1) {
                  xAxis.majorDelta= 3600000;
                  xAxis.minorDelta= 720000;
                  lastRange = 1;

                  xAxis.labelProvider.formatLabel = (unixTimestamp) => {
                    var s = new Date(unixTimestamp)
                    s = new Date(s.getFullYear(), s.getMonth(), s.getDate(), s.getHours(), s.getMinutes())
                    var formated = moment(s).format("DD.MM, HH:mm")
                    return formated
                  };

                } else if (rangeDiff / 86400000 > 2 && lastRange != 2) {
                  xAxis.majorDelta= 86400000;
                  xAxis.minorDelta= 17280000;
                  lastRange = 2;

                  xAxis.labelProvider.formatLabel = (unixTimestamp) => {
                    var formated = moment(unixTimestamp).format("DD.MM")
                    return formated
                  };
                }
            });
        },
        async reloadSciChart() {
            if(this.sciChartSurface != null) {
                if(this.sciChartSurface.renderableSeries != null){
                    this.sciChartSurface.renderableSeries.items = [];
                }

                await this.populateSciChart(false)
            }
        },
        async populateSciChart(init) {
             this.data.forEach((e, i) => {
                var d = []
                var d2 = []
                var v = []
                var v2 = []
                var value = e.xValues.filter(x => !isNaN(x))[0]

                if(value == undefined){
                    value = parseInt(e.title)
                }

                //DF-1
                var c1 = new Date(this.dateFrom)
                c1.setSeconds(c1.getSeconds() - 1)
                d2.push(c1)
                if(e.xValues.length != 2){
                    d2.push(this.dateFrom)
                }
                //DTs
                e.yValues.forEach((dt, j) => {
                    d.push(new Date(moment(dt, "DD.MM.YYYY HH.mm.ss")))
                    d2.push(new Date(moment(dt, "DD.MM.YYYY HH.mm.ss")))
                })
                //DT+1
                if(e.xValues.length != 2){
                    d2.push(this.dateTo)
                }
                var e1 = new Date(this.dateTo)
                e1.setSeconds(e1.getSeconds() + 1)
                d2.push(e1)

                v2.push(NaN)
                v2.push(value)
                if(e.xValues.length != 2){
                    e.xValues.forEach((val, j) => {
                        v.push(val)
                        v2.push(!isNaN(val) ? NaN : value)
                    })
                }
                v2.push(value)
                v2.push(NaN)

                if(v.some(x => !isNaN(x))){
                    const dataSeries = new XyDataSeries(this.wasmContext, {
                        xValues: d.map(z => !isNaN(z) ? parseInt(z) : z),
                        yValues: v
                    })

                    dataSeries.dataSeriesName = e.title;

                    const lineSeries = new FastLineRenderableSeries(this.wasmContext, {
                        dataSeries,
                        drawNaNAs: ELineDrawMode.DiscontinuousLine,
                        stroke: '#E06C65',
                        strokeThickness: this.devices > 20 ? 8 : 15
                    })

                    lineSeries.strokeColor = '#E06C65'
                    lineSeries.rolloverModifierProps.tooltipTitle = e.title
                    lineSeries.rolloverModifierProps.tooltipTextColor = '#fff'
                    lineSeries.rolloverModifierProps.tooltipColor = e.strokeColor;
                    lineSeries.rolloverModifierProps.tooltipLabelX = this.labelX ? this.labelX : "X";
                    // lineSeries.rolloverModifierProps.tooltipLabelY = this.labelY ? this.labelY : "Y";
                    this.sciChartSurface.renderableSeries.add(lineSeries);
                }

                d2 = d2.sort((a,b) => new Date(a) - new Date(b))

                const greenDataSeries = new XyDataSeries(this.wasmContext, {
                    xValues: d2.map(z => !isNaN(z) ? parseInt(z) : z),
                    yValues: v2
                })

                greenDataSeries.dataSeriesName = e.title;

                const lineSeries2 = new FastLineRenderableSeries(this.wasmContext, {
                    drawNaNAs: ELineDrawMode.DiscontinuousLine,
                    stroke: '#84CA85',
                    strokeThickness: this.devices > 20 ? 5 : 10
                })

                lineSeries2.dataSeries = greenDataSeries;

                // lineSeries2.rolloverModifierProps.tooltipTitle = e.title
                // lineSeries2.rolloverModifierProps.tooltipTextColor = '#fff'
                // lineSeries2.rolloverModifierProps.tooltipColor = e.strokeColor;
                // lineSeries2.rolloverModifierProps.tooltipLabelX = this.labelX ? this.labelX : "X";
                this.sciChartSurface.renderableSeries.add(lineSeries2);
            })

            if(init) {
                if(this.zoomBySelection == true) this.sciChartSurface.chartModifiers.add(new RubberBandXyZoomModifier({ xyDirection: EXyDirection.XDirection }));
                if(this.pan != false ) this.sciChartSurface.chartModifiers.add(new ZoomPanModifier({ xyDirection: EXyDirection.XDirection }));
                if(this.zoom != false) this.sciChartSurface.chartModifiers.add(new ZoomExtentsModifier({ xyDirection: EXyDirection.XDirection }));
                if(this.mouseZoom != false) this.sciChartSurface.chartModifiers.add(new MouseWheelZoomModifier({ xyDirection: EXyDirection.XDirection }));
                // const rolloverModifier = new RolloverModifier();
                // rolloverModifier.showRolloverLine = false;
                // this.sciChartSurface.chartModifiers.add(rolloverModifier);

                this.sciChartSurface.chartModifiers.add(new CursorModifier({
                    crosshairStroke: "#0095B2",
                    crosshairStrokeThickness: 1,
                    tooltipContainerBackground: "#000",
                    tooltipTextStroke: "#0095B2",
                    showTooltip: false,
                    axisLabelFill: "#0095B2",
                    axisLabelStroke: "#fff",
                }))
            }

            if (this.devices > 20) {
              if (!this.sciChartSurface.chartModifiers.items.some(x => x.dragMode)) {
                this.sciChartSurface.chartModifiers.add(new YAxisDragModifier({
                  dragMode: EDragMode.Panning
                }))
              }

              this.sciChartSurface.yAxes.items[0].autoTicks = false;
              this.sciChartSurface.yAxes.items[0].visibleRange = new NumberRange(1, 20);
              this.sciChartSurface.yAxes.items[0].majorDelta = 5;
              this.sciChartSurface.yAxes.items[0].minorDelta = 1;
            }

            this.sciChartSurface.zoomExtents();
        },
        changeDataSet(index, init) {
            var set = [...this.dataset]
            var res = []

            set.forEach((e, i) => {
                var dev = { xValues: [], yValues: [], title: -1 }
                e.item1.forEach((at, j) => {
                    if(at.item2 == this.selectedAlarmType ) {
                        at.item1.forEach((a, k) => {
                            if(new Date(a.createDate) >= this.dateFrom && new Date(a.createDate) <= this.dateTo){
                                var c1 = new Date(a.createDate)
                                c1.setSeconds(c1.getSeconds() - 1)
                                dev.yValues.push(c1)
                                dev.xValues.push(NaN)

                                dev.yValues.push(new Date(a.createDate))
                                if(new Date(a.endDate) > this.dateTo){
                                    dev.yValues.push(new Date(this.dateTo))
                                    var e1 = new Date(this.dateTo)
                                    e1.setSeconds(e1.getSeconds() + 1)
                                    dev.yValues.push(e1)
                                } else {
                                    dev.yValues.push(new Date(a.endDate))
                                    var e1 = new Date(a.endDate)
                                    e1.setSeconds(e1.getSeconds() + 1)
                                    dev.yValues.push(e1)
                                }
                                dev.xValues.push(parseInt(e.item2))
                                dev.xValues.push(parseInt(e.item2))

                                dev.xValues.push(NaN)
                            }
                        })
                    }
                })

                dev.title = e.item2

                if(dev.yValues.length != 0) {
                    dev.yValues.sort((a,b) => new Date(a) - new Date(b))
                } else {
                    dev.yValues.push(this.dateFrom)
                    dev.yValues.push(this.dateTo)
                    dev.xValues.push(NaN)
                    dev.xValues.push(NaN)
                }

                res.push(dev)
            })

            this.data = [...res];
            if(init == false)
                this.reloadSciChart();
        },
        dateChanged(dateFrom, dateTo) {
            if(this.init == false){
                return;
            }
            this.dateFrom = dateFrom
            this.dateTo = dateTo

            this.checkAvailableAlarmTypes()
            this.changeDataSet(this.activeSet, false)
        },
        checkAvailableAlarmTypes() {
            this.changingType = true;
            var newSelection = [];

            this.dataset.forEach((e, i) => {
                e.item1.forEach((at, j) => {
                    at.item1.forEach((a, k) => {
                        if(new Date(a.createDate)  >= new Date(this.dateFrom) && new Date(a.createDate)  <= new Date(this.dateTo)){
                            if(!newSelection.includes(at.item2)){
                                newSelection.push(at.item2)
                            }
                        }
                    })
                })
            })

            if(newSelection.length != 0){
                newSelection.sort((a, b) => a.localeCompare(b))

                if(!newSelection.includes(this.selectedAlarmType)){
                    this.selectedAlarmType = newSelection[0]
                }
            }

            this.availableAlarmTypes = [...newSelection]
            this.changingType = false;
        },
        applyStyles(){
            this.sciChartSurface.applyTheme({
                annotationsGripsBackroundBrush: "white",
                annotationsGripsBorderBrush: "white",
                axis3DBandsFill: "#1F3D6833",
                axisBandsFill: "#1F3D6833",
                axisPlaneBackgroundFill: "Transparent",
                columnFillBrush: "white",
                columnLineColor: "white",
                cursorLineBrush: "#6495ED99",
                defaultColorMapBrush: [
                    { offset: 0, color: "DarkBlue" },
                    { offset: 0.5, color: "CornflowerBlue" },
                    { offset: 1, color: "#FF22AA" }
                ],
                downBandSeriesFillColor: "#6495ED99", // "#52CC5490",
                downBandSeriesLineColor: "#E26565FF",
                downBodyBrush: "white",
                downWickColor: "white",
                gridBackgroundBrush: "white",
                gridBorderBrush: "white",
                labelBackgroundBrush: "#6495EDAA",
                labelBorderBrush: "#6495ED",
                labelForegroundBrush: "#EEEEEE",
                legendBackgroundBrush: "#1D2C35",
                lineSeriesColor: "#0095B2",
                majorGridLineBrush: "#1F3D68",
                minorGridLineBrush: "#102A47",
                mountainAreaBrush: "white",
                mountainLineColor: "white",
                overviewFillBrush: "white",
                planeBorderColor: "white",
                rolloverLineBrush: "#FD9F2533",
                rubberBandFillBrush: "#99999933",
                rubberBandStrokeBrush: "#99999977",
                sciChartBackground: "#0D213A",
                scrollbarBackgroundBrush: "white",
                scrollbarBorderBrush: "white",
                scrollbarGripsBackgroundBrush: "white",
                scrollbarViewportBackgroundBrush: "white",
                scrollbarViewportBorderBrush: "white",
                shadowEffectColor: "white",
                textAnnotationBackground: "#6495EDAA",
                textAnnotationForeground: "#EEEEEE",
                tickTextBrush: "#6495ED",
                upBandSeriesFillColor: "white",
                upBandSeriesLineColor: "white",
                upBodyBrush: "#6495EDA0",
                upWickColor: "#6495ED"
            });
        },
        datediff(first, second) {
            // Take the difference between the dates and divide by milliseconds per day.
            // Round to nearest whole number to deal with DST.
            return Math.round(( second - first ) / (1000 * 60 * 60 * 24));
        },
		changeAlarmType(aT){
        	this.selectedAlarmType = aT.description
			this.refreshChartSize()
		},
		async refreshChartSize(){
			// await this.sleep(100)
            var el = document.getElementById('scichart-root-' + this.sid)
            if(el != null) {
                el.style.height = this.$refs.multipleFilters.offsetHeight != null ? 'calc(80vh - ' + this.$refs.multipleFilters.offsetHeight + 'px)' : '80vh'
            }
		},
		async sleep(ms) {
		 	return new Promise(resolve => {setTimeout(resolve, ms)})
        }
    },
    mounted: async function() {
        this.checkAvailableAlarmTypes()
        this.changeDataSet(this.activeSet, true)
        await this.initSciChart();
        this.init = true;
		await this.refreshChartSize()

        this.resizeObserver = new ResizeObserver((entry) => {
            this.refreshChartSize()
        })

        this.resizeObserver.observe(document.querySelector('#multipleFilters'))
    },
    beforeDestroy: async function() {
        if(this.sciChartSurface || this.wasmContext){
            this.sciChartSurface = null
            this.wasmContext = null
        }
        this.sciChartSurface = null
        this.wasmContext = null

        var element = document.querySelector('#multipleFilters')
        if(element != null) {
            this.resizeObserver.unobserve(element)
        }
    },
    updated: async function(){
        if(this.dataset.length == 0){
            // this.selectionChanged()
        }
    },
}
</script>

<style>
#sciTable.e-grid .e-selectionbackground.e-rowcell {
    background-color: rgba(255, 255, 255, 0.05);
}

#sciTable.e-grid .e-row.whiteText .e-rowcell {
    color: #fff;
    font-weight: 600;
    font-size: 13px;
    line-height: 16px;
}

select {
    /* border: none; */
    padding: 5px;
    width: 100%;
}

select:focus {
    outline: none;
    border-bottom: 1px solid #0095b2;
}

option {
    padding: 4px;
}

option:checked {
    background: #347C93;
    color: white;
}

/* .info-field {
    border-bottom: 1px solid #E9E9E9;
    margin-bottom: 12px;
    margin-top: 12px;
} */

.info-field-title {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;

    padding-right: 20px;
    color: #272727;
    margin: 0;
}

.info-field-row {
    width: 100%;
    margin: 0;
    padding-bottom: 5px;
	word-break: break-word;
}

.info-field-value {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;

    color: #272727;
}

.alert-no-alarms {
    z-index: 11;
    position: absolute;
    top: 50%;
    left: calc(50% - 162px);
    align-items: center;
    justify-content: center;
    font-weight: 600;
    padding: 40px;
    background-color: #fefefe;
    border: 1px solid #888;
    width: auto;
    border-radius: 5px;
    box-shadow: 0px 4px 10px rgba(0,0,0,0.2);
}
</style>



// WEBPACK FOOTER //
// src/components/Charts/SciChartMultipleOverview.vue